export const INVALID_EMAIL = 'Invalid Email address';
export const INVALID_PHONE = 'Invalid Phone number';
export const PASSWORD_TOO_SHORT = 'Password too short';
export const PASSWORDS_MUST_MATCH = 'Passwords must match';
export const REQUIRED = 'Required';
